import { MARKETMAP_ERROR, MARKETMAP_HIDE_ERROR, MARKETMAP_SELECTED_DATA, MARKETMAP_START_LOADER, MARKETMAP_STOP_LOADER, MARKETMAP_STREAM, } from "../../interface/iMarketMap";
import { marketStreamingUpdate } from "@domains/features/Markets/Equity/utils/streamingUpdate";
const initialState = {
    data: null,
    selectedData: {
        data: null,
        totalCount: 0,
        maxProgressBar: 0,
        barPercentageName: null,
        basePersentage: 0,
        barGraphData: null,
        messageData: {
            show: false,
            msg: "",
            icon: null,
        },
    },
    marketMapLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    updatedTime: "",
};
const marketMaps = (state = initialState, action) => {
    switch (action.type) {
        case MARKETMAP_SELECTED_DATA:
            return Object.assign(Object.assign({}, state), { selectedData: action.payload.selectedData, updatedTime: action.payload.updatedTime });
        case MARKETMAP_STREAM:
            return Object.assign(Object.assign({}, state), { selectedData: Object.assign(Object.assign({}, state.selectedData), { data: marketStreamingUpdate(state.selectedData.data, action.payload.qouteStream) }), updatedTime: action.payload.qouteStream.updatedTime });
        case MARKETMAP_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARKETMAP_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MARKETMAP_START_LOADER:
            return Object.assign(Object.assign({}, state), { marketMapLoader: true });
        case MARKETMAP_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { marketMapLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default marketMaps;
